import React, { useEffect, useState, useContext, createContext } from "react";
import { useParams } from 'react-router-dom'
import "../css/client_page.css";
import "../css/edit_client_projects.css";
import { getTimestamp30DaysAgo, getTimestampToday } from "../helpers/date_conversion"
import { getStuff, postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { authenticatedContext } from '../App'
import { ButtonWIcon, MyDatePicker, TextArea, TextInput, CloseButton} from './Inputs'
import { insertSpaceEveryNChars, makeDictFromList} from "../helpers/misc";
import { convertTimestampToCzech} from "../helpers/date_conversion"
import { Tags } from './Tags'
import { ClientProjectOverview } from './ClientProjectOverview'
import { useNavigate } from "react-router-dom";
import { EditClientProjects } from './EditClientProjects'
import { FormatDaysOnProject } from './HelperComponents'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export const newAidContext = createContext()

const ClientPage = () => {

    const { id } = useParams()
    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);


    const [activeProjId, setActiveProjId] = useState(0);
    const [clientData, setClientData] = useState(null);
    const [editProjMode, setEditProjMode] = useState(false);
    const [newAidOpen, setNewAidOpen] = useState(false);

    const emptyAidRecords = {
        for_period: [getTimestamp30DaysAgo(), getTimestampToday()],
        aid_records: []
    }

    function updateClientData() {
        getStuff(`client/${id}/`).then((res) => {
            if (res.status === 200) {
                let client_data = res.data
                client_data.projects.push({
                    project_id: 0,
                    project_name: "Souhrn všech projektů"
                })
                client_data.aid_records = emptyAidRecords
                client_data.projects = makeDictFromList(client_data.projects, "project_id")
                setClientData(client_data);
            } else if (res.status === 401) {
                setAuthenticated(false);
            } else {
                console.log("error", res)
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }

    useEffect(() => {
        updateClientData();
    }, [])

    function handleEditProjMode() {
        setEditProjMode(!editProjMode)
    }

    function getDaysOnProject() {
        console.log(clientData["projects"][activeProjId])
        const days_on_project = clientData["projects"][activeProjId].days_on_project
        const days_on_project_spent = clientData["projects"][activeProjId].days_on_project_spent
        if (!days_on_project)
            return <div></div>
        return <FormatDaysOnProject days={days_on_project} daysSpent={days_on_project_spent} />

    }

    if (clientData == null) return "Načítám vaše data..";
    if (!editProjMode) {
        return (
            <div className="client-page">
                <div className="sidebar-container">
                    <ClientSideBar data={clientData} id={id} updateClientData={updateClientData} />
                </div>
                <div className="main-container">
                    <div className="project-nav client-nav">
                        <div className="nav-items">
                            {

                                Object.entries(clientData.projects).map(([projectId, project]) => {
                                    return(
                                        <div className={`nav-item ${activeProjId == projectId ? 'active' : ''}`}
                                            onClick={() => { setActiveProjId(projectId) }}>{project.project_name}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <ButtonWIcon
                            className="edit-projects-button"
                            iconSrc={"/img/svg/edit.svg"}
                            text={"editovat"}
                            onClick={handleEditProjMode} />
                    </div>
                    <div className="client-projects-container">
                        {activeProjId !=0 &&
                        <table className="info-table">
                            <tbody>
                                <tr>
                                    <td className="info-label">
                                        ČLENEM OD{" "}
                                    </td>
                                    <td className="info-value">{convertTimestampToCzech(clientData.projects[activeProjId].link_ts, true, false)}</td>
                                </tr>
                                <tr>
                                    <td className="info-label">ČLENEM DO</td>
                                    <td className="info-value">{clientData.projects[activeProjId].unlink_ts || ""}</td>
                                </tr>
                                <tr>
                                    <td className="info-label">DNY NA PROJEKTU</td>
                                    <td className="info-value">{getDaysOnProject()}</td>
                                </tr>
                            </tbody>
                        </table>
                        }
                        {
                            <newAidContext.Provider value={[newAidOpen, setNewAidOpen]}>
                                <ClientProjectOverview projectId={activeProjId} clientId={id} />
                            </newAidContext.Provider>
                        }
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <EditClientProjects id={id}>
                <CloseButton onClick={handleEditProjMode}/>
            </EditClientProjects>)
    }
};

export default ClientPage;

function ClientSideBar({ data, id, updateClientData }) {

    const [editMode, setEditMode] = useState(false)

    function handleEditClick() {
        setEditMode(!editMode)
    }


    return (
        <>
            <div className="profile-sidebar">
                {editMode ? <EditClientInfo data={data} handleEditClick={handleEditClick} clientId={id} updateClientData={updateClientData} /> : <ClientInfo handleEditClick={handleEditClick} data={data} clientId={id} />}
                <Tags client_id={id}></Tags>
            </div>
        </>
    );
}


function EditClientInfo({ data, handleEditClick, clientId, updateClientData }) {
    const [firstName, setFirstName] = useState(data.first_name)
    const [lastName, setLastName] = useState(data.last_name)
    const [birthDate, setBirthDate] = useState(data.birth_date)
    const [email, setEmail] = useState(data.email)
    const [telNumber, setTelNumber] = useState(data.tel_number)
    const [cardNumber, setCardNumber] = useState(data.card_number)
    const [note, setNote] = useState(data.note)

    const [showSave, setShowSave] = useState(false)
    const [errorMess, setErrorMess] = useState(null)

    const addAlertBanner = useContext(AlertsContext);

    useEffect(() => {
        if (firstName !== data.first_name || lastName !== data.last_name || birthDate !== data.birth_date || email !== data.email || telNumber !== data.tel_number || cardNumber !== data.card_number || note !== data.note) {
            setShowSave(true)
        } else {
            setShowSave(false)
        }

    },
        [firstName, lastName, birthDate, email, telNumber, cardNumber, note])



    function handleSave() {
        if (!/^[a-zA-Zá-žÁ-Ž]+$/.test(firstName) || !/^[a-zA-Zá-žÁ-Ž]+$/.test(lastName) || firstName.length < 2 || lastName.length < 2) {
            setErrorMess("Neplatné jméno či příjmení");
            return false;
        }
        else if (email && email.length > 0 && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email)) {
            setErrorMess("Neplatný email");
            return;
        }
        else if (telNumber && telNumber.length > 0 && !/^\d{9}$/.test(telNumber)) {
            setErrorMess("Neplatné telefonní číslo");
            return;
        }
        else if (cardNumber && cardNumber.length > 0 && (!/^\d+$/.test(cardNumber))) {
            setErrorMess("Neplatné číslo karty");
            return;
        }
        else if (note && note.length > 500) {
            setErrorMess("Poznámka je příliš dlouhá")
            return;
        }
        else {
            setErrorMess(null);
        }

        const data = {
            client_id: clientId,
            first_name: firstName,
            last_name: lastName,
            birth_date: birthDate,
            email: email,
            tel_number: telNumber,
            card_number: cardNumber,
            note: note
        }

        postStuff("update_client/", data).then((res) => {
            try {
                if (res.status === 200) {
                    addAlertBanner("Změny uloženy", "success")
                    handleEditClick();
                    updateClientData();
                } else if (res.status === 400) {
                    addAlertBanner("Chyba! " + res.data.error, "warning")
                } else if(res.status == 403){
                    addAlertBanner("Nemáte dostatečné oprávnění","warning")
                }
                else {
                    addAlertBanner("Něco se pokazilo", "danger")
                }
            } catch (error) {
                addAlertBanner("Něco se pokazilo", "danger")
            }
        })

    }

    return (
        <div className="profile-info-card edit">
            <div className="profile-info-card-img-controls">
                <div className="profile-controls-container">
                    <CloseButton  onClick={handleEditClick} />
                </div>
                <div className="profile-icon-container">
                    <img
                        loading="lazy"
                        src="/img/svg/user_in_circle_purple.svg"
                        className="profile-image"
                        alt="Profile"
                    />
                </div>
            </div>
            <table className="profile-details">
                <tbody>
                    <tr>
                        <td className="profile-label">JMÉNO</td>
                        <td className="profile-value">
                            <TextInput value={firstName} setValue={setFirstName} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">PŘÍJMENÍ</td>
                        <td className="profile-value">
                            <TextInput value={lastName} setValue={setLastName} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">NAROZENÍ</td>
                        <td className="profile-value">
                            <MyDatePicker value={birthDate} setValue={setBirthDate} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">EMAIL</td>
                        <td className="profile-value">
                            <TextInput email value={email} setValue={setEmail} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">TELEFON</td>
                        <td className="profile-value">
                            <TextInput tel value={telNumber} setValue={setTelNumber} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">ČÍSLO KARTY</td>
                        <td className="profile-value">
                            <TextInput value={cardNumber} setValue={setCardNumber} />
                        </td>
                    </tr>
                    <tr>
                        <td className="profile-label">POZNÁMKA:</td>
                        <td className="profile-value"></td>
                    </tr>
                    <tr>
                        <td className="profile-value-note" colSpan="2">
                            <TextArea value={note} setValue={setNote} />
                        </td>
                </tr>
                </tbody>
            </table>
            {errorMess != null && <div className="error emes">{errorMess}</div>}
            {showSave && <ButtonWIcon
                iconSrc={"/img/svg/save.svg"}
                onClick={handleSave}
                style={{ backgroundColor: "#68E965" }}
                text={"Uložit"} />
            }
        </div>
    )
}


function ClientInfo({ data, handleEditClick }) {

    let tel_n = data.tel_number ? insertSpaceEveryNChars(data.tel_number.toString(), 3) : null;
    const addAlertBanner = useContext(AlertsContext);

    const navigate = useNavigate()

    if (data.dial_code && data.tel_number) {
        tel_n = `+${data.dial_code} ${tel_n}`
    }

    function handleDeletePress() {

        confirmAlert({
            title: 'Opravdu chcete smazat klienta?',
            message: 'Smazáním klienta odstraníte i všechny přidružené záznamy o pomoci',
            buttons: [
              {
                label: 'Ano',
                onClick: deleteClient
              },
              {
                label: 'Ne'
              }
            ]
          });

    }

    function deleteClient(){
        postStuff("delete_client/", { client_id: data.client_id }).then((res) => {
            try {
                if (res.status === 200) {
                    addAlertBanner("Klient smazán", "success")
                    navigate("/clients")
                } else if (res.status === 403) {
                    addAlertBanner("Nemáte dostatečné oprávnění.", "warning")
                }
                else if (res.status === 400) {
                    addAlertBanner("Chyba! " + res.data.error, "warning")
                } else {
                    addAlertBanner("Něco se pokazilo", "danger")
                }
            } catch (error) {
                addAlertBanner("Něco se pokazilo", "danger")
            }
        })
    }

    return (<div className="profile-info-card">
        <div className="profile-info-card-img-controls">
            <div className="profile-controls-container">
                <ButtonWIcon iconSrc={"/img/svg/edit.svg"} onClick={handleEditClick} />
                <ButtonWIcon iconSrc={'/img/svg/bin.svg'} onClick={handleDeletePress} />
            </div>
            <div className="profile-icon-container">
                <img
                    loading="lazy"
                    src="/img/svg/user_in_circle_purple.svg"
                    className="profile-image"
                    alt="Profile"
                />
            </div>
        </div>
        <table className="profile-details">
            <tbody>
                <tr>
                    <td className="profile-label">JMÉNO</td>
                    <td className="profile-value">{data.first_name}</td>
                </tr>
                <tr>
                    <td className="profile-label">PŘÍJMENÍ</td>
                    <td className="profile-value">{data.last_name}</td>
                </tr>
                <tr>
                    <td className="profile-label">NAROZENÍ</td>
                    <td className="profile-value">{data.birth_date && convertTimestampToCzech(data.birth_date)}</td>
                </tr>
                <tr>
                    <td className="profile-label">EMAIL</td>
                    <td className="profile-value">{data.email}</td>
                </tr>
                {tel_n &&
                    <tr>
                        <td className="profile-label">TELEFON</td>
                        <td className="profile-value">{tel_n}</td>
                    </tr>
                }
                <tr>
                    <td className="profile-label">ČÍSLO KARTY</td>
                    <td className="profile-value">{data.card_number ? data.card_number : " - "}</td>
                </tr>
                <tr>
                    <td className="profile-label client-note-td">POZNÁMKA</td>
                    <td className="profile-value"></td>
                </tr>
                <tr>
                    <td className="profile-value-note" colSpan="2">{data.note ? <DisplayWithLineBreaks text={data.note} /> : " - "}</td>
                </tr>
            </tbody>
        </table>
    </div>)
}

function DisplayWithLineBreaks({ text }) {
    return text.split('\n').map((str, index) => <React.Fragment key={index}>{str}<br /></React.Fragment>);
}
